import React from 'react';
interface LogoProps {
  className?: string;
  dark?: boolean;
}
export function Logo({
  className = '',
  dark = false
}: LogoProps) {
  const textColor = dark ? 'text-white' : 'text-navy';
  const triColor = dark ? '#38BDF8' : '#2563EB';
  return <div className={`flex items-center gap-2.5 ${className}`} aria-label="PRISMA" data-id="element-33">
      {/* Prism mark */}
      <svg width="26" height="24" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" data-id="element-34">
        <path d="M13 2 L24 22 L2 22 Z" stroke={triColor} strokeWidth="2.2" strokeLinejoin="round" data-id="element-35" />
        {/* refraction facet */}
        <path d="M13 2 L13 22" stroke={triColor} strokeWidth="1.4" opacity="0.45" data-id="element-36" />
        <path d="M13 12 L24 22" stroke={triColor} strokeWidth="1.4" opacity="0.45" data-id="element-37" />
      </svg>
      <span className={`font-bold tracking-tight text-xl leading-none ${textColor}`} data-id="element-38">
        PRISMA
      </span>
    </div>;
}